<template>
  <v-dialog hide-overlay max-width="800px" v-model="show">
    <v-card>
      <v-card-title>补事业部</v-card-title>
      <v-card-actions>
        <v-btn @click="save()">保存</v-btn>
        <v-btn @click="cancel()">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-form>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <remote-autocomplete
                  label="事业本部"
                  url="divisions/kv?type=BU"
                  v-model="po.buId"
                ></remote-autocomplete>
              </v-flex>
              <v-flex xs12>
                <remote-autocomplete
                  label="事业部"
                  :url="`divisions/kv?type=DEPARTMENT&buId=${po.buId}`"
                  v-model="po.departmentId"
                ></remote-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      po: {},
    }
  },
  methods: {
    save() {
      this.$http
        .put(
          `/${this.po.id}/purchase-orders/add-department/${
            this.po.departmentId
          }`
        )
        .then(() => {
          this.$message('', 'SUCCESS')
        })
    },
    popup(po) {
      this.show = true
      this.po = po
    },
    cancel() {
      this.show = false
    },
  },
}
</script>
